module.exports = {
  FETCH_IMPCS_OF_SINGLE_INBOUND_OPERATOR_REQUEST: 'FETCH_IMPCS_OF_SINGLE_INBOUND_OPERATOR_REQUEST',
  FETCH_IMPCS_OF_SINGLE_INBOUND_OPERATOR_SUCCESS: 'FETCH_IMPCS_OF_SINGLE_INBOUND_OPERATOR_SUCCESS',
  FETCH_IMPCS_OF_SINGLE_INBOUND_OPERATOR_FAILURE: 'FETCH_IMPCS_OF_SINGLE_INBOUND_OPERATOR_FAILURE',
  FETCH_IMPCS_OF_SINGLE_OUTBOUND_OPERATOR_REQUEST: 'FETCH_IMPCS_OF_SINGLE_OUTBOUND_OPERATOR_REQUEST',
  FETCH_IMPCS_OF_SINGLE_OUTBOUND_OPERATOR_SUCCESS: 'FETCH_IMPCS_OF_SINGLE_OUTBOUND_OPERATOR_SUCCESS',
  FETCH_IMPCS_OF_SINGLE_OUTBOUND_OPERATOR_FAILURE: 'FETCH_IMPCS_OF_SINGLE_OUTBOUND_OPERATOR_FAILURE',
};
